var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubLogoCompactNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 56,
    viewBox: "0 0 143 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2183_342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2373 0H16.7627C7.5049 0 0 7.5049 0 16.7627V39.2373C0 48.4951 7.5049 56 16.7627 56H39.2373C48.4951 56 56 48.4951 56 39.2373V16.7627C56 7.5049 48.4951 0 39.2373 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.144 11.2H11.2V18.144H18.144V11.2Z",
    fill: "#00DD39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.144 11.2H11.2V18.144H18.144V11.2Z",
    fill: "#00DD39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9653 11.2H25.088V18.144H32.9653C35.6085 18.144 37.7515 20.2944 37.7515 22.9301V37.7514H22.9301C20.2869 37.7514 18.144 35.601 18.144 32.9653V25.0879H11.2V32.9653C11.2 39.4464 16.4491 44.6954 22.9301 44.6954H44.6955V22.9301C44.6955 16.449 39.4464 11.2 32.9653 11.2Z",
    fill: "#004E2B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.176 26.432V17.6H94.616V40H89.176V31.328H78.936V40H73.496V17.6H78.936V26.432H89.176ZM112.132 32.256V23.008H117.252V40H112.452L112.292 37.664C111.076 39.2 108.868 40.352 106.212 40.352C102.116 40.352 99.5883 37.536 99.5883 32.736V23.008H104.708V31.904C104.708 34.528 105.828 35.904 108.196 35.904C110.372 35.904 112.132 34.464 112.132 32.256ZM133.41 22.656C138.242 22.656 141.922 26.368 141.922 31.488C141.922 36.672 138.338 40.352 133.41 40.352C130.946 40.352 128.77 39.424 127.458 38.176L127.33 39.968H122.562V16.32H127.714V24.768C129.026 23.552 131.106 22.656 133.41 22.656ZM132.194 36C135.01 36 136.898 34.176 136.898 31.488C136.898 28.8 135.01 27.008 132.194 27.008C129.314 27.008 127.426 28.8 127.426 31.488C127.426 34.176 129.314 36 132.194 36Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2183_342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubLogoCompactNegative);
export default __webpack_public_path__ + "static/media/Hub-Logo-Compact-Negative.284d2de9e3d0c71b2b00ebfebb22f9f2.svg";
export { ForwardRef as ReactComponent };